<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <!-- Start Main Loader -->
    <transition name="fadeInUp" mode="out-in" v-if="loaderPage">
      <MainLoader />
    </transition>
    <!-- End Main Loader -->

    <div class="custom_card" v-else>
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row">
            <!-- Start:: Ar nationality -->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isArabic"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.ar.nationality"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.nationality_ar") }}
                </label>
              </div>
            </div>
            <!-- End:: Ar nationality -->

            <!-- Start:: En nationality -->
            <div class="col-lg-4 py-0">
              <div class="input_wrapper top_label">
                <input
                  @keypress="isEnglish"
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.en.nationality"
                />
                <label for="name_input" class="form-label">
                  {{ $t("forms.labels.nationality_en") }}
                </label>
              </div>
            </div>
            <!-- End:: En nationality -->

            <!-- Start:: Is Active -->
            <div class="col-lg-12 py-0">
              <v-checkbox
                :label="$t('forms.labels.is_active')"
                v-model="data.is_active"
                color="success"
              ></v-checkbox>
            </div>
            <!-- End:: Is Active -->

            <!-- Start:: Map -->
            <!-- <div class="col-lg-12" v-if="data.area">
              <base-map
                @markersChanged="merkersChanged"
                :biggingMarkers="data.area"
              />
            </div> -->
            <!-- end:: Map -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="button_style_1" :disabled="btnIsLoading">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",

  props: ["id"],

  data() {
    return {
      // ========== Main Loader
      loaderPage: false,

      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.nationalities.title"),
          disabled: false,
          href: "/nationality/show-all",
        },
        {
          text: this.$t("breadcrumb.nationalities.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data
      data: {
        flag: null,
        ar: {
          name: null,
          slug: null,
          currency: null,
          nationality: null,
        },
        en: {
          name: null,
          slug: null,
          currency: null,
          nationality: null,
        },
        // short_name: null,
        continent: null,
        phone_code: null,
        phone_number_limit: null,
        area: [],
        is_active: false,
        time_zone: null,
      },
      time_zones: null,

      // ========== create_data
    };
  },

  methods: {
    merkersChanged(data) {
      this.area = data;
    },

    // Get_Data
    getData() {
      this.loaderPage = true;
      this.$axios({
        method: "GET",
        url: `nationality/${this.id}`,
      }).then((res) => {
        this.loaderPage = false;

        this.data.ar.nationality = res.data.data.ar.nationality;
        this.data.en.nationality = res.data.data.en.nationality;
        this.data.is_active = res.data.data.is_active;
      });
    },

    // Uplode Image
    uplodeImg_1(obj) {
      this.data.flag = obj;
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.ar.nationality) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.nationality"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.nationality) {
        this.$iziToast.error({
          timeout: 2000,
          message: this.$t("forms.validation.nationality"),
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("_method", "PUT");
      submit_data.append("ar[nationality]", this.data.ar.nationality);
      submit_data.append("en[nationality]", this.data.en.nationality);
      submit_data.append("is_active", +this.data.is_active);

      this.$axios({
        method: "POST",
        url: `nationality/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/nationality/show-all" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    getTimeZones() {
      this.$axios.get("get_time_zones").then((res) => {
        this.time_zones = res.data.data;
      });
    },
  },

  created() {
    this.getTimeZones();
    this.getData();
  },
};
</script>
